export default function CountSkeleton() {
  return <span className="placeholder placeholder-xs col-1"></span>;
}
